import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";

import { UserService } from "@core/services/user.service";
import { Observable } from "rxjs";

export function tokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {

	const authToken = inject(UserService).getToken();
	if (authToken) {

		req = req.clone({
			setHeaders: {
				'Authorization': `Bearer ${authToken}`
			}
		});
	}

	return next(req);
}